import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Lock, Eye, EyeOff, Phone } from 'lucide-react';
import Button from './components/Button';

import { devLog } from '../../../utils/devLog';
const Signup = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ fullName: '', email: '', phone: '', password: '', confirmPassword: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) { alert('Passwords do not match!'); return; }
        devLog.log('Sign up:', formData);
        navigate('/template1');
    };

    const inputClass = "w-full pl-11 pr-4 py-2.5 md:py-3 border border-[#E5E7EB] text-sm focus:outline-none focus:border-[#2D6A4F] transition-colors";

    return (
        <div className="min-h-screen bg-white flex" style={{ fontFamily: "'Poppins', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            {/* Left Side - Image */}
            <div className="hidden lg:flex flex-1 bg-[#1B4332] items-center justify-center p-12 relative overflow-hidden">
                <img
                    src="https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=800"
                    alt="Indian fashion"
                    className="absolute inset-0 w-full h-full object-cover opacity-30"
                />
                <div className="relative text-center z-10">
                    <h2 className="text-3xl font-semibold text-white mb-3">Join PRIYA</h2>
                    <p className="text-white/70 text-base">Start your journey with handcrafted Indian fashion</p>
                </div>
            </div>

            {/* Right Side - Form */}
            <div className="flex-1 flex items-center justify-center p-6 md:p-8">
                <div className="w-full max-w-md">
                    <div className="text-center mb-6">
                        <h1 onClick={() => navigate('/template1')} className="text-2xl md:text-3xl font-semibold text-[#2D6A4F] cursor-pointer mb-1 tracking-wider">PRIYA</h1>
                        <p className="text-sm text-[#6B7280]">Create your account</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Full Name</label>
                            <div className="relative">
                                <User className="absolute left-4 top-1/2 -translate-y-1/2 text-[#9CA3AF]" size={16} />
                                <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} required className={inputClass} placeholder="Your full name" />
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Email</label>
                            <div className="relative">
                                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-[#9CA3AF]" size={16} />
                                <input type="email" name="email" value={formData.email} onChange={handleInputChange} required className={inputClass} placeholder="you@example.com" />
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Phone</label>
                            <div className="relative">
                                <Phone className="absolute left-4 top-1/2 -translate-y-1/2 text-[#9CA3AF]" size={16} />
                                <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required className={inputClass} placeholder="+91 98765 43210" />
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Password</label>
                            <div className="relative">
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-[#9CA3AF]" size={16} />
                                <input type={showPassword ? 'text' : 'password'} name="password" value={formData.password} onChange={handleInputChange} required minLength="8" className="w-full pl-11 pr-11 py-2.5 md:py-3 border border-[#E5E7EB] text-sm focus:outline-none focus:border-[#2D6A4F] transition-colors" placeholder="Min 8 characters" />
                                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-[#9CA3AF] hover:text-[#6B7280]">
                                    {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                                </button>
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Confirm Password</label>
                            <div className="relative">
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-[#9CA3AF]" size={16} />
                                <input type={showPassword ? 'text' : 'password'} name="confirmPassword" value={formData.confirmPassword} onChange={handleInputChange} required minLength="8" className={inputClass} placeholder="Confirm password" />
                            </div>
                        </div>

                        <div className="flex items-start">
                            <input type="checkbox" required className="mt-1 mr-2 accent-[#2D6A4F]" />
                            <span className="text-xs text-[#6B7280]">
                                I agree to the{' '}
                                <button type="button" onClick={() => navigate('/template1/terms-conditions')} className="text-[#2D6A4F] hover:underline">Terms & Conditions</button>
                                {' '}and{' '}
                                <button type="button" onClick={() => navigate('/template1/privacy-policy')} className="text-[#2D6A4F] hover:underline">Privacy Policy</button>
                            </span>
                        </div>

                        <Button type="submit" variant="primary" size="lg" fullWidth>Create Account</Button>
                    </form>

                    <div className="my-5 flex items-center">
                        <div className="flex-1 border-t border-[#E5E7EB]"></div>
                        <span className="px-4 text-xs text-[#9CA3AF]">OR</span>
                        <div className="flex-1 border-t border-[#E5E7EB]"></div>
                    </div>

                    <button className="w-full flex items-center justify-center gap-3 px-6 py-2.5 border border-[#E5E7EB] hover:bg-[#F8FAF8] transition-colors text-sm">
                        <svg className="w-4 h-4" viewBox="0 0 24 24">
                            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                        </svg>
                        Continue with Google
                    </button>

                    <p className="text-center mt-5 text-sm text-[#6B7280]">
                        Already have an account?{' '}
                        <button onClick={() => navigate('/template1/login')} className="text-[#2D6A4F] font-medium hover:underline">Sign in</button>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Signup;
